import JSEncrypt from 'jsencrypt';

import AddressController from '../controllers/addressController';
import Service from '../services/services';
import AccountModel from './accountModel';
import ProfileModel from './profileModel';
import DashboardModel from './dashboardModel';
import AddressConfigModel from './addressConfigModel';
import { getInitialGroupType } from '../helpers/helpers';

class AddressModel extends AccountModel {
    constructor(ProfileModel) {
        super();

        this.userAddresses = []; //where all of addresses associated with an account are stored
        this.qasAddress = [];
        this.selectedBillingAddress = '';
        this.gpAutocompleteOn = false;
        this.userPayments = [];
        this.orphanPayments = [];
        this.tempOrphans = [];
        this.deletedAddress = {
            siblingId: '',
            isFirst: false
        };
        this.deletedPayment = {
            siblingId: '',
            isFirst: false
        };
        this.relationships = {
            profile: ProfileModel,
            addressConfig: AddressConfigModel
        };

        this.initialized = {
            address: {},
            userAddresses: {},
            userPayments: {}
        };
        this.qas = {
            ran: false,
            status: '',
            results: ''
        };
        this.errors = {
            location: '',
            data: ''
        };
        this.temp = {};
    }

    createOrphans() {
        let orphanPayments = [];
        this.userPayments === undefined ? this.userPayments = [] : this.userPayments;

        if (this.userAddresses !== '' && this.userAddresses !== undefined) {
            orphanPayments = this.userPayments.filter(payment => {
                let noAddressFound = true;
                this.userAddresses.forEach((address, index) => {
                    if (address.id === payment.creditCardDetail.addressId) {
                        noAddressFound = false;
                    }
                })
                return noAddressFound;
            });
        } else {
            orphanPayments = this.userPayments;
        }

        return Promise.resolve(super.setData(orphanPayments, 'orphanPayments', true));
    }

    submitNewPayment(model, selector, modelProperty, session, serviceMethod, viewModel, makeServiceCall, result) {
        return new Promise((resolve, reject) => {
            this.getPaymentForm(selector)
                .then(form => {
                    return this.buildPayments(model, selector, modelProperty, session, serviceMethod, form, result, viewModel);
                })
                .then(done => {
                    return resolve(done);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    showSelectedAddress(model, selector, modelProperty, session, serviceMethod, store) {
        let editSelectedAddressId = $(selector).attr('data-address-id');
        let selectedAddress;
        model.userAddresses.forEach(function(address, index) {
            if (address.id == editSelectedAddressId) {
                selectedAddress = address;
            }
        });

        let tempAddress = $.extend(true, this.temp, selectedAddress);
        return Promise.resolve(tempAddress);
    }

    showSelectedPayment(model, selector, modelProperty, session, serviceMethod) {
        let editSelectedAddressId = $(selector).attr('data-payment-id');
        let temporaryPayments;
        model.userPayments.forEach((payment, index) => {
            if (payment.id == editSelectedAddressId) {
                temporaryPayments = payment;
                this.selectedBillingAddress = payment.creditCardDetail.addressId;
            }
        });

        return Promise.resolve($.extend(true, this.temp, temporaryPayments));
    }

    updateAddress(model, selector, modelProperty, session, serviceMethod, viewModel) {
        let _this = this;
        let $addressFormInputs = $(selector).parents('form').find('.js-address-form-item');
        let $addressFormLength = $addressFormInputs.length;
        let currentAddressId = $(selector).attr('data-address-id');
        let currentIndex;

        $addressFormInputs.each(function(index) {
            let $this = $(this);
            let parts = $this.attr('name');
            let value = null;

            if (parts === 'address.poBox') {

                if ($this.is(':checked')) {
                    value = true;
                } else {
                    value = false;
                }

            } else {
                value = model.sanitizeInput($this.val());
            }

            model.recursiveData(parts, value, model[modelProperty.temp], model);
        });

        model.temp.id = currentAddressId;

        if(typeof model.temp.address !== 'undefined' && typeof model.temp.address.groupType !== 'undefined') {
            const tempAddress = _.omit(model.temp.address, 'groupType');
            model.temp.address = tempAddress;
        }

        return super.updateData(model, session, serviceMethod, modelProperty, viewModel, AddressController, selector);
    }

    updatePayments(model, selector, modelProperty, session, serviceMethod, viewModel) {
        let _this = this;
        let $addressFormInputs = $(selector).parents('form').find('.js-account-payment-form-item');
        let currentAddressId = $(selector).attr('data-payment-id');

        $addressFormInputs.each(function(index) {
            let $this = $(this);
            let parts = $this.attr('name');
            let value = $this.val();
            model.recursiveData(parts, value, model[modelProperty.temp], model);
        });

        model.temp.id = currentAddressId;
        model.temp.paymentType = 'CREDIT_CARD';

        return super.updateData(model, session, serviceMethod, modelProperty, viewModel, AddressController, selector);
    }

    updatePaymentsAddress($paymentId, address, session, viewModel, selector) {
        let paymentId = $($paymentId).attr('data-id');
        let addressId = address.data.id;

        this.userPayments.forEach((payment, index) => {
            if (payment.id == paymentId) {
                this.tempPayment = payment;
            }
        });

        this.tempPayment.creditCardDetail.addressId = addressId;

        return super.updateData(this, session, 'updatePayment', {
            temp: 'tempPayment',
            prop: 'userPayments'
        }, viewModel, AddressController, selector);
    }

    createAddress(model, selector, modelProperty, session, serviceMethod, viewModel) {
        if (viewModel.viewStates.newAddressInPaymentForm || viewModel.viewStates.newAddress || viewModel.viewStates.editAddress) {
            this.temp = {};
            const _this = this;
            const $addressFormInputs = $('.js-address-edit-form').find('.js-address-form-item');
            $addressFormInputs.each(function(index) {
                const $this = $(this);
                const parts = $this.attr('name');
                let value = null;

                if (parts === 'address.poBox') {

                    if ($this.is(':checked')) {
                        value = true;
                    } else {
                        value = false;
                    }

                } else {
                    value = model.sanitizeInput($this.val());
                }

                model.recursiveData(parts, value, model[modelProperty.temp], model);
            });

            this.temp.id = undefined;
            return super.updateData(model, session, serviceMethod, modelProperty, viewModel, AddressController, selector);
        } else {
            return Promise.resolve(true);
        }
    }

    createQASAddress(model, selector, modelProperty, session, serviceMethod, viewModel, makeServiceCall, result) {
        this.temp = {};
        const $addressFormInputs = $('.js-address-edit-form').find('.js-address-form-item');
        $addressFormInputs.each(function(index) {
            const $this = $(this);
            const parts = $this.attr('name');
            const value = $this.val();
            model.recursiveData(parts, value, model[modelProperty.temp], model);
        });
        this.temp.address.address1 = this.qas.results[0];
        this.temp.address.address2 = this.qas.results[1];
        this.temp.address.city = this.qas.results[2];
        this.temp.address.region = this.qas.results[3];
        this.temp.address.postalCode = this.qas.results[4];
        this.temp.address.country = this.qas.results[5] === "UNITED STATES OF AMERICA" ? 'US' : 'CA';
        this.temp.id = undefined;
        return super.updateData(model, session, serviceMethod, modelProperty, viewModel, AddressController, selector);
    }

    saveTemps(model, selector) {
        const _this = this;
        const form = $(selector).parents('form');
        let $formInputs;

        if (selector.hasClass('js-account-submit-new-card-payments') || selector.hasClass('js-account-payment-edit-save')) { // add/edit card
            $formInputs = form.find('.js-account-payment-form-item, .js-address-form-item');
        } else if (selector.hasClass('js-account-address-new-save') || selector.hasClass('js-account-address-edit-save')) { // add/edit address
            $formInputs = form.find('.js-address-form-item');
        } else {
            $formInputs = [];
        }

        $formInputs.each(function(index) {
            const $this = $(this);
            const parts = $this.attr('name');
            const value = $this.val();
            model.recursiveData(parts, value, _this.temp, _this);
        });

        return Promise.resolve(this);
    }

    deleteAddress(model, selector, modelProperty, session, serviceMethod, viewModel) {
        let currentAddressId = $(selector).attr('data-address-id');
        model.userAddresses.forEach(function(address, index) {
            if (address.id == currentAddressId) {
                let removedAddress = model.userAddresses.splice(index, 1);
            }
        });
        this.setInitialized('userAddresses', false, false)
        return Service[serviceMethod](currentAddressId, session, model, viewModel, AddressController, selector);
    }

    deletePayment(model, selector, modelProperty, session, serviceMethod, viewModel) {
        let _this = this;
        let currentPaymentId = $(selector).attr('data-payment-id');
        let currentIndex;
        let relationshipsDefaultPaymentId = _this.get('relationships').profile.profile.defaultPaymentId;

        if (relationshipsDefaultPaymentId === currentPaymentId) {
            DashboardModel.relationships.profile.profile.defaultPaymentId = '';
        }

        model.userPayments.forEach(function(payment, index) {
            if (payment.id == currentPaymentId) {
                currentIndex = index;

                let addressToRemove = model.userPayments.splice(currentIndex, 1);
                model.tempPayment = addressToRemove[0];

            }
        });

        _this.editablePayment = '';
        return _this.updateData(model, session, serviceMethod, modelProperty, viewModel, AddressController, selector);

    }

    setSelectedCountry(model, selector, modelProperty, session, serviceMethod) {
        return AddressConfigModel.setSelectedCountry(model, selector, modelProperty, session, serviceMethod);
    }

    setCountryGroupType(model, selector, modelProperty, session, serviceMethod) {
        return AddressConfigModel.setCountryGroupType(model, selector, modelProperty, session, serviceMethod);
    }

    setTempAddressGroupType(groupType) {
        const _this = this;
        return new Promise((resolve,reject)=>{
            if (_.isObject(_.get(_this, 'temp.address'))) {
                _this.temp.address.groupType = groupType;

                // reset address3 on group type change
                if (_.get(_this, 'temp.address.address3')) {
                    _this.temp.address.address3 = '';
                }
            }
            resolve(_this);
        });
    }

    setPxpPublicKey(pxpData) {
        const _this = this;
        return new Promise((resolve, reject) => {

            _this.pxpData = pxpData;

            resolve(_this);
        });
    }

    getPaymentForm(selector) {
        return new Promise(function(resolve, reject) {
            resolve($(selector).parents('form'));
        })
    }

    buildPayments(model, selector, modelProperty, session, serviceMethod, form, results, viewModel) {
        const pxpData = _.get(model, 'pxpData');
        this.temp = {};
        let _this = this;
        let paymentInputs = form.find('.js-account-payment-form-item');
        //return new Promise(function(resolve,reject){
        paymentInputs.each(function(index) {
            let $this = $(this);
            let parts = $this.attr('name');
            let value = $this.val();
            if (parts === 'creditCardDetail.cardType') {
                let currentCard = _this.get('temp');
                value = _this.detectCardType(currentCard.creditCardDetail.cardNumber);
            }
            if (parts === 'creditCardDetail.addressId' && value === 'new-address') {
                value = results[1].data.id;
            }
            model.recursiveData(parts, value, model[modelProperty.temp], model);
        });
        this.temp.paymentType = 'CREDIT_CARD';
        this.temp.visible = true;
        this.temp.nickName = '';
        this.temp.ccImgSrc = undefined;
        this.temp.creditCardDetail.cardType = this.temp.creditCardDetail.cardType.toUpperCase();

        if (pxpData) {
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(pxpData.publicKey);
            const creditCardNumber = this.temp.creditCardDetail.cardNumber;
            const updatedDetails = {
                paymentGateway: 'PXP',
                lastFourDigits: creditCardNumber.slice(creditCardNumber.length - 4),
                cardNumber: encrypt.encrypt(creditCardNumber),
                encryptionDetails: {
                    encryptionId: pxpData.encryptionId,
                    encryptionType: 'rsaTwoFourZeroEight',
                },
            };
            this.temp.creditCardDetail = Object.assign(
                this.temp.creditCardDetail,
                updatedDetails,
            );
        }

        return super.updateData(model, session, serviceMethod, modelProperty, viewModel, AddressController, selector);
        //})
    }

    // takes the form field value and returns true on valid number - Luhn algorithm
    valididateCreditCard(value) {
        // accept only digits, dashes or spaces
        if (/[^0-9-\s]+/.test(value)) return false;

        var nCheck = 0,
            nDigit = 0,
            bEven = false;
        value = value.replace(/\D/g, "");

        for (let n = value.length - 1; n >= 0; n--) {
            let cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);

            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }

            nCheck += nDigit;
            bEven = !bEven;
        }

        return (nCheck % 10) == 0;
    }

    clearCCImg(model, selector, modelProperty, session, serviceMethod, viewModel, makeServiceCall, result) {
        this.tempPayment.ccImgSrc = '';
        this.tempPayment.creditCardDetail.cardType = '';
    }

    /**
     * Method called from addressViewModel to update the credit card type (e.g. Visa, Mastercard, etc.).
     * Passes detectcardType() card number to determine card type.
     * This is used to append the card type name an img src. (src="/images/paymenticons/icon_")
     * to display credit card image.
     * @param {String} selector
     * @param {Object} viewModel
     */
    setCardTypeOnBlur(model, selector, modelProperty, session, serviceMethod, viewModel, makeServiceCall, result) {
        return new Promise((resolve, reject) => {

            if (viewModel.viewStates.newPayment && !this.temp) {
                this.temp = {};
            }

            if (this.temp.creditCardDetail === undefined) {
                this.temp.creditCardDetail = {};
            }

            let cardNum = $(selector).parents('form').find('.js-account-card-number-payments').val();

            this.temp.ccImgSrc = "/images/paymenticons/icon_";
            cardNum = cardNum.replace(/\s/g, '');
            parseInt(cardNum);

            if (this.detectCardType(cardNum) === undefined) {
                this.temp.creditCardDetail.cardType = '';
                this.temp.creditCardDetail.cardNumber = '';
                resolve(this);
            } else {
                this.temp.creditCardDetail.cardType = this.detectCardType(cardNum);
                this.temp.creditCardDetail.cardNumber = cardNum;
                this.temp.ccImgSrc += this.temp.creditCardDetail.cardType.toUpperCase() + '.gif';
                resolve(this);
            }
        });
    }

    /**
     * A method that gets passed a String of numbers to determine a credit card type
     * @param {String} number
     */
    detectCardType(number) {

        const re = {
            electron: /^(4026|417500|4405|4508|4844|4913|4917)/,
            maestro: /^(5018|5081|5044|5020|5038|603845|6304|6759|676[1-3]|6799|6220|504834|504817|504645)[0-9]{8,15}$/,
            interpayment: /^(636)/,
            unionpay: /^(6[2,4,5]|81[0-7][0-1])/,
            visa: /^4/,
            mastercard: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)/,
            amex: /^3[47][0-9]{13}/,
            diners: /^(36|38|2014|2149|30[0-5])/,
            discover: /^(6011)/,
            jcb: /^35(2[89]|[3-8])/
        };
        if (re.electron.test(number)) {
            return 'VISA';
        } else if (re.maestro.test(number)) {
            return 'MSTRO';
        } else if (re.unionpay.test(number)) {
            return 'CUP';
        } else if (re.visa.test(number)) {
            return 'Visa';
        } else if (re.mastercard.test(number)) {
            return 'MC';
        } else if (re.amex.test(number)) {
            return 'AMEX';
        } else if (re.diners.test(number)) {
            return 'DCI';
        } else if (re.discover.test(number)) {
            return 'DISC';
        } else if (re.jcb.test(number)) {
            return 'JCB';
        } else {
            return undefined;
        }
    }

    /**
     * Digest the garbage response from the Google Places API and add its values to the Address Model
     * @param  {Array} place Array of objects that correspond to each address field returned by the Places API
     * @return {Object}      The Address Model
     */
    selectGooglePlace(place) {
        const cityObj = place.filter(this.findAddressType, 'locality')[0];
        const streetNumberObj = place.filter(this.findAddressType,'street_number')[0];
        const routeObj = place.filter(this.findAddressType,'route')[0];
        const regionObj = place.filter(this.findAddressType,'administrative_area_level_1')[0];
        const postalCodeObj = place.filter(this.findAddressType,'postal_code')[0];
        const countryObj = place.filter(this.findAddressType,'country')[0];

        const city = _.get(cityObj, 'long_name', '');
        const streetNumber = _.get(streetNumberObj, 'long_name', '');
        const route = _.get(routeObj, 'short_name', '');
        const region = _.get(regionObj, 'short_name', '');
        const postalCode = _.get(postalCodeObj, 'long_name', '');
        const country = _.get(countryObj, 'short_name', '');

        const updatedAddress = {
            address1: `${streetNumber} ${route}`,
            city: city,
            region: region,
            postalCode: postalCode,
            country: country
        }

        if (this.temp.address) {
            Object.assign(this.temp.address, updatedAddress);
        } else {
            this.temp.address = updatedAddress;
        }

        $('#address1').val(updatedAddress.address1);

        return Promise.resolve(this);
    }

    /**
     * A boolean check to make sure we're working with the correct field
     * @param  {Object} aType The current iteration of the address field
     * @return {boolean}      Whether we're on the correct iteration of the Places array or not
     */
    findAddressType(aType) {
        return aType.types[0] == this;
    }

    /**
     * A method that allows the submission of a new address on an orphan payment by
     * creating an address first so address id can be applied to the payment's addressId.
     * After an address is created, the method checks to see if the address was set to
     * be a default shipping address, then creates payment.
     *
     * @param {Object} model
     * @param {String} selector
     * @param {Object} modelProperty
     * @param {String} session
     * @param {String} serviceMethod
     * @param {Object} viewModel
     */
    addAddressToOrphan(model, selector, modelProperty, session, serviceMethod, viewModel) {

        const $addressFormInputs = $(selector).parents('form').find('.js-account-payment-form-item');
        const paymentId = $(selector).attr('data-payment-id');
        const paymentServiceMethod = 'updatePayment';

        // applies payment to existing address
        if ($('#billing-address-payments').val() !== 'new-address') {
            $addressFormInputs.each(function(index) {
                const $this = $(this);
                const parts = $this.attr('name');
                const value = $this.val();
                model.recursiveData(parts, value, model[modelProperty.temp], model);
            });

            model.temp.id = paymentId;
            model.temp.paymentType = 'CREDIT_CARD';

            return Promise.resolve(super.updateData(model, session, paymentServiceMethod, {
                temp: 'temp',
                prop: modelProperty.paymentProp
            }, viewModel, AddressController, selector));
        } else {
            // A three step promise chain
            return new Promise((resolve, reject) => {
                // first: create address
                this.createAddress(this, selector, {
                    temp: 'temp',
                    prop: modelProperty.addressProp
                }, session, 'createAddress', viewModel)

                // second: check to set address as default
                .then(addressResponse => {
                    const defaultPaymentIsChecked = $('.js-account-set-default-address').is(':checked');

                    if (defaultPaymentIsChecked) {
                        ProfileModel.temp = {
                            defaultShippingAddressId: addressResponse.data.id,
                            emailAddress: ProfileModel.profile.emailAddress
                        };

                        this.updateData(ProfileModel, session, 'updateProfile', {
                            temp: 'temp',
                            prop: 'profile'
                        }, viewModel, AddressController, selector);
                        Promise.resolve(ProfileModel.profile);
                    }
                    return Promise.resolve(addressResponse);
                })

                // third: create payment
                .then(addressResponse => {
                    this.temp = {};
                    $addressFormInputs.each(function(index) {
                        const $this = $(this);
                        const parts = $this.attr('name');
                        const value = $this.val();
                        model.recursiveData(parts, value, model[modelProperty.temp], model);
                    });

                    model.temp.creditCardDetail.addressId = addressResponse.data.id;
                    model.temp.id = paymentId;
                    model.temp.paymentType = 'CREDIT_CARD';

                    return resolve(super.updateData(model, session, paymentServiceMethod, {
                        temp: 'temp',
                        prop: modelProperty.paymentProp
                    }, viewModel, AddressController, selector));
                })
            });
        }
    }

    /**
     * Update the data model when an edit address form should be focused upon
     * @param  {object} model         The current model (Address model)
     * @param  {object} selector      The DOM element that triggered the event
     * @param  {string} modelProperty The model property to update
     * @return {undefined}            Returns nothing
     */
    handleEditAddressFocus(model, selector, modelProperty) {
        super.setData($(selector).attr('data-address-id'), modelProperty, false);
    }

    /**
     * Update the data model when an edit form should lose focus
     * @param  {object} model         The current model (Address model)
     * @param  {object} selector      The DOM element that triggered the event
     * @param  {string} modelProperty The model property to update
     * @return {undefined}            Returns nothing
     */
    handleEditExit(model, selector, modelProperty) {
        super.setData('', modelProperty, false);
    }

    /**
     * Update the data model when an edit payment form should be focused upon
     * @param  {object} model         The current model (Address model)
     * @param  {object} selector      The DOM element that triggered the event
     * @param  {string} modelProperty The model property to update
     * @return {undefined}            Returns nothing
     */
    handleEditPaymentFocus(model, selector, modelProperty) {
        super.setData($(selector).attr('data-payment-id'), modelProperty, false);
    }
}

let Address = new AddressModel(ProfileModel);

export default Address;
